import { connect } from 'react-redux';

import { getIsHotelOnly } from 'src/store/view/selectors';
import withMobile from '../../CheckoutRoutes/PackageCheckout/hocs/withMobile';
import { getNightsInHotel } from '../../store/selectors/package';
import {
  getSearcherNights,
  getSimilarPackagesHasAdjustParams,
} from '../../store/selectors/similar-packages';

import { setNightsAction } from '../../store/actions/similar-packages';
import SearchParamsNights from '../ShortInfo/SearchParams/SearchParamsNights';

const mapStateToProps = (state) => ({
  nights: getSearcherNights(state),
  nightsInHotel: getNightsInHotel(state),
  hasAdjustParams: getSimilarPackagesHasAdjustParams(state),
  isHotelOnly: getIsHotelOnly(state),
});

const mapDispatchToProps = (dispatch) => ({
  onChangeNights: (value) => dispatch(setNightsAction(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(SearchParamsNights));
